import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import GroupValidations from 'scaleflow/validators/group';

export interface QuickAddsGroupSignature {
  // The arguments accepted by the component
  Args: {
    isOpen?: boolean;
    handleFormDismiss?: () => void;
    onItemSaved?: (group: any) => void;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

export default class QuickAddsGroupComponent extends Component<QuickAddsGroupSignature> {
  @service declare store: any;
  @service declare router: any;

  group = {
    title: '',
  };
  groupValidations = GroupValidations;

  @action
  async onSubmit(changeset: any, e: Event) {
    e.preventDefault();
    try {
      await changeset.validate();
      if (changeset.isInvalid) {
        console.debug(changeset.errors);
        return;
      }
      const group = this.store.createRecord('group', {
        title: changeset.title,
      });
      await group.save();
      this.args?.onItemSaved?.(group);
      this.handleModalDismiss();
    } catch (err) {
      console.log(err);
    }
  }

  @action
  handleModalDismiss() {
    this.args?.handleFormDismiss?.();
  }
}
